import clsx from "clsx";
import { defineMessages, useIntl } from "react-intl";

import type { MessageStatus } from "@customTypes/message";

import styles from "./MessageStatusIndicator.module.css";

type Props = {
  status?: MessageStatus;
};

const statusMessages = defineMessages({
  sent: {
    id: 'global.messageStatus.sent',
    defaultMessage: 'Sent',
    description: 'Delivery status shown for an outgoing message that was successfully sent'
  },
  delivered: {
    id: 'global.messageStatus.delivered',
    defaultMessage: 'Delivered',
    description: 'Delivery status shown for an outgoing message that was delivered'
  },
  failed: {
    id: 'global.messageStatus.failed',
    defaultMessage: 'Failed',
    description: 'Delivery status shown for an outgoing message that failed to send'
  },
});

const statusSymbol = {
  sent: '\u2714', //Heavy check mark
  delivered: '\u2714\u2714',
  failed: '\u2718', //Heavy ballot x
};

const MessageStatusIndicator = ({ status}: Props) => {
  const intl = useIntl();

  if (!status) return null;

  return (
    <span
      className={clsx(
        styles.statusIcon,
        {
          [styles.failed]: status === 'failed'
        }
      )}
      title={intl.formatMessage(statusMessages[status])}
    >
      {statusSymbol[status]}
    </span>
  );
};

export default MessageStatusIndicator;
